import styled from 'styled-components';

import { GridItem } from '@xing-com/grid';
import { SingleSizeIllustrationErrorGenericSmall } from '@xing-com/illustrations';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  scale000,
  scale290,
  space3XL,
  space4XL,
  space5XL,
  spaceL,
  spaceS,
  spaceXL,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

const StyledGridItem = styled(GridItem)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: ${space4XL} ${scale000} ${space5XL};

  @media ${mediaSmallOrTiny} {
    margin: ${space3XL} ${scale000} ${space4XL};
  }
`;

const StyledIllustrationErrorGenericSmall = styled(
  SingleSizeIllustrationErrorGenericSmall
)`
  width: ${scale290};
  height: ${scale290};
`;

const StyledHeadline = styled(Headline)`
  margin: ${spaceXL} ${scale000} ${spaceS};
`;

const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: ${spaceL};
`;

export const Styled = {
  GridItem: StyledGridItem,
  IllustrationErrorGenericSmall: StyledIllustrationErrorGenericSmall,
  Headline: StyledHeadline,
  BodyCopy: StyledBodyCopy,
};
